import useSWR from "swr";
import { PROXY } from "../lib/utils";

const fetcher = async (url) => {
  const response = await fetch(url);
  if (!response.ok) throw new Error("Failed to fetch course filter options");
  return response.json();
};

export default function useCourseFilterOptions() {
  const { data, error, isLoading } = useSWR(`${PROXY}/courses/filter-options`, fetcher, {
    revalidateOnFocus: false,
    dedupingInterval: 60_000,
  });

  return {
    teachers: Array.isArray(data?.teachers) ? data.teachers : [],
    universities: Array.isArray(data?.universities) ? data.universities : [],
    error,
    isLoading,
  };
}
